import { IVoice, Providers } from '@d-id/types';

const PRO_PROVIDERS = [Providers.Elevenlabs, Providers.Google, Providers.AzureOpenAi];

export const isProPlus = (voice: IVoice | null) => Boolean(voice?.provider && PRO_PROVIDERS.includes(voice.provider));
